import { render, staticRenderFns } from "./sfc-sidebar-ads.vue?vue&type=template&id=60e8be4e&scoped=true&lang=pug&"
import script from "./sfc-sidebar-ads.vue?vue&type=script&lang=js&"
export * from "./sfc-sidebar-ads.vue?vue&type=script&lang=js&"
import style0 from "./sfc-sidebar-ads.vue?vue&type=style&index=0&id=60e8be4e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8be4e",
  null
  
)

export default component.exports